import { Col, Row, Card, Modal, Button, Flex, Spin } from 'antd'
import commonStyles from '../../Utils/Common.less'
import { useLocation, useNavigate } from 'react-router-dom'
import AddNewButton from '../../Components/AddNewButton'
import React, { useEffect, useState } from 'react'
import CreateTask from '../../Components/CreateTask'
import { EyeOutlined } from '@ant-design/icons'
import GlobelClientTaps from './clientOverViewDashbordTap'
import { connect, useDispatch } from 'react-redux'
import { type ClientOverviewDashBordStateInterface } from '../../Types/GlobelSearchClient/GlobelSearchClient'
import { GetCilent } from '../../Services/GlobelSearch'
import style from './Buttons/taps.less'
import PortfolioView from '../../Components/viewProfolioDetails'
import { FORMAT_DATE } from '../../Utils/dateFormat'
const GlobelSearchClient = (
    props: ClientOverviewDashBordStateInterface
): React.ReactElement => {
    const { clientDashbordList, isLoading } = props
    const dispatch = useDispatch()
    const location = useLocation()
    const navigate = useNavigate()
    const refernceNumber = location.state?.value
    const parts = refernceNumber.split('-')
    const businessId = parts[0]
    const refernceId = parts[1]
    const [isEditModalVisible, setEditModalVisible] = useState(false)
    const [portfolioModel, setportfolioModel] = useState(false)
    const [restData, setResetData] = useState('false')
    useEffect(() => {
        GetCilent(dispatch, businessId, refernceId)
    }, [refernceNumber])

    const openEditModal = (): void => {
        setEditModalVisible(true)
    }

    const closeEditModal = (): void => {
        setEditModalVisible(false)
    }

    const handleCloseModal = (): void => {
        setEditModalVisible(false)
    }

    const handleNavigation = (businessId: string): void => {
        localStorage.removeItem('corporateData')
        localStorage.removeItem('onbordingId')
        const corporateData = {
            corporateid: clientDashbordList?.referenceId,
            companyname: clientDashbordList?.clientName,
            companyregisternumber: clientDashbordList?.additionalDataOne,
            clientnumber: clientDashbordList?.clientNumber,
            activestatus: clientDashbordList?.companyStatus,
            emailAddress: clientDashbordList?.emailAddress,
            contactName: clientDashbordList?.contactName,
            mobilenumber: clientDashbordList?.contactNumber,
            alternativeEmailAddress: clientDashbordList?.altEmailAddress,
        }

        const SoleTraderData = {
            soleTraderId: clientDashbordList?.referenceId,
            businessTradingName: clientDashbordList?.clientName,
            clientNumber: clientDashbordList?.clientNumber,
            activestatus: clientDashbordList?.companyStatus,
            emailAddress: clientDashbordList?.emailAddress,
            contactName: clientDashbordList?.contactName,
            mobilenumber: clientDashbordList?.contactNumber,
            alternativeEmailAddress: clientDashbordList?.altEmailAddress,
            serviceIds: clientDashbordList?.serviceList,
        }
        const individualData = {
            individualId: clientDashbordList?.referenceId,
            tradingName: clientDashbordList?.clientName,
            clientNumber: clientDashbordList?.clientNumber,
            activestatus: clientDashbordList?.companyStatus,
            emailAddress: clientDashbordList?.emailAddress,
            name: clientDashbordList?.contactName,
            mobilenumber: clientDashbordList?.contactNumber,
            alternativeEmailAddress: clientDashbordList?.altEmailAddress,
        }
        const partnershipData = {
            partnershipId: clientDashbordList?.referenceId,
            tradingName: clientDashbordList?.clientName,
            clientNumber: clientDashbordList?.clientNumber,
            activestatus: clientDashbordList?.companyStatus,
            emailAddress: clientDashbordList?.emailAddress,
            name: clientDashbordList?.contactName,
            mobilenumber: clientDashbordList?.contactNumber,
            alternativeEmailAddress: clientDashbordList?.altEmailAddress,
            serviceIds: clientDashbordList?.serviceList,
            partnershipUTR: clientDashbordList?.additionalDataOne,
        }
        const onbordingId = clientDashbordList?.clientNumber === '#' ? 2 : 1
        switch (businessId) {
            case '1':
                localStorage.setItem(
                    'corporateData',
                    JSON.stringify(corporateData)
                )
                localStorage.setItem('onbordingId', onbordingId.toString())
                navigate(
                    onbordingId === 1
                        ? `/clients/registered-clients/corporate-view`
                        : `/clients/onboarding-clients/corporate-view`
                )

                break
            case '2':
                navigate(
                    onbordingId === 1
                        ? `/clients/registered-clients/soletrader-view`
                        : `/clients/onboarding-clients/soletrader-view`,
                    {
                        state: { SoleTraderData, onbordingId },
                    }
                )
                break
            case '3':
                navigate(
                    onbordingId === 1
                        ? `/clients/registered-clients/individual-view`
                        : `/clients/onboarding-clients/individual-view`,
                    {
                        state: { individualData, onbordingId },
                    }
                )
                break
            case '4':
                navigate(
                    onbordingId === 1
                        ? `/clients/registered-clients/partnership-view`
                        : `/clients/onboarding-clients/partnership-view`,
                    {
                        state: { partnershipData, onbordingId },
                    }
                )
                break
            default:
                // Handle other cases or do nothing
                break
        }
    }
    return (
        <>
            <div>
                <h1>Client Dashboard</h1>
            </div>
            <Card
                title={`${clientDashbordList?.clientName}- ${clientDashbordList?.clientNumber}`}
                extra={
                    <>
                        <Flex gap={8}>
                            <Button
                                type="primary"
                                onClick={() => {
                                    setportfolioModel(true)
                                }}
                            >
                                Portfolio Info
                            </Button>
                            <Button
                                icon={<EyeOutlined />}
                                type="primary"
                                onClick={() => {
                                    handleNavigation(businessId)
                                }}
                            >
                                Client Info
                            </Button>
                            <AddNewButton
                                name="Create Task"
                                clickAction={() => {
                                    openEditModal()
                                    setResetData('true')
                                }}
                            />
                        </Flex>
                    </>
                }
                className={commonStyles.card}
            >
                <Spin spinning={isLoading} size={'large'}>
                    {clientDashbordList?.missedInfo !== null &&
                        clientDashbordList?.missedInfo.length > 0 && (
                            <div className={style.misstingInfo}>
                                <b>Missing Information </b>:-{' '}
                                {clientDashbordList?.missedInfo}
                            </div>
                        )}
                    <Flex vertical gap={15}>
                        <Row gutter={[16, 48]}>
                            <Col span={4}>Contact Name</Col>
                            <Col span={7}>
                                : {clientDashbordList?.contactName}
                            </Col>
                            <Col span={5}>Service List</Col>
                            <Col span={8}>
                                :{' '}
                                {clientDashbordList?.serviceList === ''
                                    ? '-'
                                    : clientDashbordList?.serviceList}
                            </Col>
                        </Row>
                        <Row gutter={[16, 48]}>
                            <Col span={4}>Contact Mail</Col>
                            <Col span={7}>
                                : {clientDashbordList?.emailAddress}
                            </Col>
                            {businessId === '1' && (
                                <>
                                    <Col span={5}>Register Number</Col>
                                    <Col span={8}>
                                        :{' '}
                                        {clientDashbordList?.additionalDataOne}{' '}
                                        -{' '}
                                        <a
                                            href={`https://find-and-update.company-information.service.gov.uk/company/${clientDashbordList?.additionalDataOne}`}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            style={{
                                                marginLeft: '8px',
                                                textDecoration: 'underline',
                                            }}
                                        >
                                            Link To Company House
                                        </a>
                                    </Col>
                                </>
                            )}
                        </Row>
                        <Row gutter={[16, 48]}>
                            <Col span={4}>Contact No</Col>
                            <Col span={7}>
                                : {clientDashbordList?.contactNumber}
                            </Col>
                            {clientDashbordList?.serviceList.includes('AA') &&
                                businessId === '1' && (
                                    <>
                                        <Col span={5}>Annual Accounts</Col>
                                        {clientDashbordList?.aaNextStatementDate !==
                                            '' &&
                                        clientDashbordList?.aaDuebyDate !==
                                            '' ? (
                                            <Col span={8}>
                                                : Next accounts made up to{' '}
                                                {FORMAT_DATE(
                                                    clientDashbordList?.aaNextStatementDate
                                                )}{' '}
                                                due by{' '}
                                                {FORMAT_DATE(
                                                    clientDashbordList?.aaDuebyDate
                                                )}
                                            </Col>
                                        ) : (
                                            <Col span={8}> : -</Col>
                                        )}
                                    </>
                                )}
                        </Row>

                        <Row>
                            <GlobelClientTaps
                                businessId={businessId}
                                refernceId={refernceId}
                            />
                        </Row>
                    </Flex>

                    <Modal
                        footer={null}
                        onCancel={closeEditModal}
                        width={'40%'}
                        title="Create Task"
                        open={isEditModalVisible}
                    >
                        <CreateTask
                            onClose={handleCloseModal}
                            setResetData={setResetData}
                            resetdata={restData}
                            clinetName={clientDashbordList?.clientName}
                            clinetrefNumber={refernceNumber}
                        />
                    </Modal>
                    <Modal
                        title="Portfolio Details"
                        open={portfolioModel}
                        onCancel={() => {
                            setportfolioModel(!portfolioModel)
                        }}
                        footer={null}
                        width={'50%'}
                    >
                        <PortfolioView
                            businessId={businessId}
                            referenceId={refernceId}
                            portfolioId={0}
                        />
                    </Modal>
                </Spin>
            </Card>
        </>
    )
}

const mapStateToProps = (state: any): ClientOverviewDashBordStateInterface => {
    return {
        clientDashbordList: state.golobelSearch.clientDashbordList,
        isLoading: state.common.isLoading,
    }
}

export default connect(mapStateToProps)(GlobelSearchClient)
